(() => {
'use strict';
const key = id => String(id).split('/').pop();
const selected = (set, value) => !set || !set.size || set.has(value);
function matchingVariants(product, state) {
  if (!selected(state.brand, product.brand) || !selected(state.category, product.category)) return [];
  return product.variants.filter(v => selected(state.colour, v.colour) && selected(state.size, v.size) && (state.min == null || v.price >= state.min) && (state.max == null || v.price <= state.max) && (Number.isFinite(Number(v.stock)) && Number(v.stock) > 0));
}
function selectProducts(products, state) {
  const matches = products.map(product => ({product, variants: matchingVariants(product, state)})).filter(item => item.variants.length);
  const min = item => {const available=item.variants.filter(v=>Number(v.stock)>0);return Math.min(...(available.length?available:item.variants).map(v=>v.price));};
  return matches.sort((a,b) => state.sort === 'price-descending' ? min(b)-min(a) || a.product.title.localeCompare(b.product.title) : state.sort === 'title-ascending' ? a.product.title.localeCompare(b.product.title) : min(a)-min(b) || a.product.title.localeCompare(b.product.title));
}
function basketTotals(lines) {
  const subtotal = lines.reduce((sum, line) => sum + line.variant.price * line.quantity, 0);
  const vat = lines.reduce((sum, line) => sum + (line.variant.taxable ? Math.round(line.variant.price * line.quantity * 0.2) : 0), 0);
  return {subtotal, vat, total: subtotal + vat};
}
function validQuantity(variant, quantity, existing = 0) {
  return Number.isInteger(quantity) && quantity > 0 && variant.stock != null && quantity + existing <= variant.stock;
}
if (typeof module !== 'undefined' && module.exports) module.exports = {matchingVariants, selectProducts, basketTotals, validQuantity};
if (typeof document === 'undefined') return;
document.querySelectorAll('[data-clearance-live]').forEach(async root => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const labels = JSON.parse(root.querySelector('[data-clearance-labels]').textContent);
  let data;
  try {
    const seed = JSON.parse(root.querySelector('[data-clearance-data]').textContent);
    if (seed.dataUrl) {
      const response = await fetch(seed.dataUrl, {credentials:'omit'});
      if (!response.ok) throw new Error('Clearance data unavailable');
      data = await response.json();
    } else data = seed;
    if (!Array.isArray(data.products)) throw new Error('Clearance data empty');
  } catch (error) {
    root.querySelector('[data-results-count]').textContent = labels.error;
    root.querySelector('[data-clearance-grid]').hidden = true;
    
    return;
  }
  const products = data.products.map(product => ({...product, variants: product.variants.filter(v => Number.isFinite(Number(v.stock)) && Number(v.stock) > 0)})).filter(product => product.variants.length);
  const byId = new Map(products.map(p => [key(p.id), p]));
  const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:'GBP'}).format(cents/100);
  const unique = values => [...new Set(values)].sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
  const sizeOrder = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  const sortSizes = values => unique(values).sort((a,b) => {
    const rank = value => {const i = sizeOrder.indexOf(value.toUpperCase()); return i < 0 ? 100 : i;};
    return rank(a)-rank(b) || a.localeCompare(b, undefined, {numeric:true});
  });
  const state = {brand:new Set(), category:new Set(), colour:new Set(), size:new Set(), min:null, max:null, stock:false, sort:'price-ascending'};
  const url = new URL(location.href);
  url.searchParams.getAll('category').forEach(value => state.category.add(value));
  const heading = root.querySelector('[data-clearance-heading]');
  if (heading && state.category.size) heading.textContent = [...state.category].join(', ') + ' — ' + labels.clearance;
  const sort = root.querySelector('[data-clearance-sort]');
  if (['price-ascending','price-descending','title-ascending'].includes(url.searchParams.get('sort_by'))) state.sort = url.searchParams.get('sort_by');
  sort.value = state.sort;
  const grid = root.querySelector('[data-clearance-grid]');
  const cards = new Map(Array.from(root.querySelectorAll('[data-clearance-card]')).map(card => [card.dataset.clearanceCard, card]));
  const empty = root.querySelector('[data-empty]');
  const count = root.querySelector('[data-results-count]');
  function node(tag, className, text) {
    const n = document.createElement(tag); if (className) n.className = className; if (text != null) n.textContent = text; return n;
  }
  function applyPrice(element, variant) {
    element.dataset.exPrice = variant.price;
    element.dataset.vatRate = variant.taxable ? '0.2' : '0';
    element.textContent = money(variant.price);
  }
  function stockText(product, variants) {
    const prefix = product.status !== 'ACTIVE' ? labels.draft+' · ' : '';
    if (!data.stockChecked) return prefix+labels.stock_pending;
    return prefix+variants.reduce((total, v) => total + Number(v.stock), 0).toLocaleString('en-GB')+' available';
  }
  sort.addEventListener('change', () => {state.sort = sort.value; render();});
  root.querySelectorAll('[data-clear-filters]').forEach(button => button.addEventListener('click', () => {
    ['brand','category','colour','size'].forEach(field => state[field].clear());
    state.min = state.max = null; state.stock = false; render();
  }));
  function render() {
    const matches = selectProducts(products,state);
    cards.forEach(card => card.hidden = true);
    matches.forEach(({product,variants}) => {
      const card = cards.get(key(product.id)); if (!card) return;
      card.hidden = false; grid.append(card);
      const priced = data.stockChecked && variants.some(v=>v.stock>0) ? variants.filter(v=>v.stock>0) : variants;
      const cheapest = [...priced].sort((a,b) => a.price-b.price)[0];
      const photo=card.querySelector('.rcl-photo img'); if(cheapest.image){photo.src=cheapest.image;photo.alt=product.title+' — '+cheapest.colour;}
      card.querySelectorAll('[data-product-link]').forEach(link => {link.href='/products/'+encodeURIComponent(product.handle)+'?clearance=1&variant='+encodeURIComponent(cheapest.id);});

      applyPrice(card.querySelector('[data-card-price]'), cheapest);
      card.querySelector('[data-card-from]').hidden = !priced.some(v => v.price !== cheapest.price);
      card.querySelector('[data-card-options]').textContent = unique(variants.map(v => v.colour)).length+' '+(unique(variants.map(v => v.colour)).length===1?labels.colour_one:labels.colours)+' · '+unique(variants.map(v => v.size)).length+' '+(unique(variants.map(v => v.size)).length===1?labels.size_one:labels.sizes);
      const swatches = card.querySelector('[data-card-swatches]');
      swatches.replaceChildren();
      unique(variants.map(v => v.colour)).forEach(colour => {
        const colourVariants = variants.filter(v => v.colour === colour);
        const choice = [...colourVariants].sort((a,b) => a.price-b.price)[0];
        const button = node('button','rcl-swatch');
        button.type = 'button'; button.title = colour;
        button.setAttribute('aria-label',labels.colour + ': ' + colour);
        button.setAttribute('aria-pressed',String(colour === cheapest.colour));
        if (choice.swatch) { const fill=node('span','rcl-swatch-fill'); fill.style.background=choice.swatch; button.append(fill); }
        else if(choice.image) { const image=node('img');image.src=choice.image;image.alt='';image.loading='lazy';button.append(image); }
        const name=node('span','rcl-swatch-name',colour);button.append(name);
        button.addEventListener('click',()=>{
          swatches.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
          if(choice.image){photo.src=choice.image;photo.alt=product.title+' — '+colour;}
          card.querySelectorAll('[data-product-link]').forEach(link=>{link.href='/products/'+encodeURIComponent(product.handle)+'?clearance=1&variant='+encodeURIComponent(choice.id);});
          applyPrice(card.querySelector('[data-card-price]'),choice);
          card.querySelector('[data-card-from]').hidden=!colourVariants.some(v=>v.price!==choice.price);
          card.querySelector('[data-card-stock]').textContent=stockText(product,colourVariants);
          window.HivisVAT?.refresh();
        });
        swatches.append(button);
      });
      const note = card.querySelector('[data-card-stock]'); note.textContent = stockText(product, variants);
      note.classList.toggle('is-in', data.stockChecked && variants.some(v => v.stock>0) && product.status === 'ACTIVE');
      note.classList.toggle('is-out', data.stockChecked && !variants.some(v => v.stock>0));
    });
    count.textContent = matches.length === 1 ? labels.result_one : labels.results.replace('__COUNT__',matches.length);
    empty.hidden = matches.length > 0;
    const nextUrl = new URL(location.href);
    ['brand','category','colour','size'].forEach(field => {nextUrl.searchParams.delete(field); state[field].forEach(value => nextUrl.searchParams.append(field,value));});
    nextUrl.searchParams.set('sort_by',state.sort);
    history.replaceState(null,'',nextUrl);
    window.HivisVAT?.refresh();
  }
  render();
});
})();

